import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-98" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-99" data-mp="et66p4p4xm5g">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-earth-200 bg-white p-8 shadow-sm sm:p-12" data-id="element-100" data-mp="eur20wj9x94d">
          <span className="inline-flex rounded-full bg-forest-800 p-4 text-gold-400" data-id="element-101" data-mp="smxd447kkpwy">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-102" data-mp="xj5nl4atnuxs" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-forest-900" data-id="element-103" data-mp="12kldparuwrn1">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-104" data-mp="25rnioykrkksr">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging mining
            class this week. If you feel your students didn't respond better or the materials didn't save you hours of
            work:
          </p>
          <p className="mt-6 rounded-lg bg-forest-50 px-5 py-4 text-lg font-extrabold text-forest-900" data-id="element-105" data-mp="1rt7djc2jv2cq">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-106" data-mp="2jkd719nrm1t1">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}